const nodes = [
    { x: 80, y: 90, r: 5, pulse: true },
    { x: 210, y: 58, r: 3 },
    { x: 340, y: 110, r: 4 },
    { x: 470, y: 70, r: 3, pulse: true },
    { x: 520, y: 172, r: 5 },
    { x: 150, y: 200, r: 4 },
    { x: 300, y: 232, r: 6, pulse: true },
    { x: 430, y: 252, r: 3 },
    { x: 92, y: 330, r: 3 },
    { x: 240, y: 360, r: 4, pulse: true },
    { x: 390, y: 382, r: 5 },
    { x: 520, y: 332, r: 3 },
    { x: 172, y: 442, r: 3 },
    { x: 332, y: 468, r: 4, pulse: true },
];

const edges = [
    [0, 1], [1, 2], [2, 3], [3, 4], [2, 6], [0, 5], [5, 6], [6, 7],
    [4, 7], [5, 8], [8, 9], [9, 10], [6, 9], [7, 10], [10, 11],
    [9, 12], [12, 13], [10, 13], [6, 10],
];

const labels = [
    { x: 300, y: 218, text: "HEAD OF AI · BENGALURU" },
    { x: 80, y: 76, text: "CTO · GLOBAL BANKING" },
    { x: 390, y: 368, text: "VP ONCOLOGY R&D · BASEL" },
];

export default function NetworkGraph({ className = "" }) {
    return (
        <svg
            viewBox="0 0 600 520"
            className={className}
            aria-hidden="true"
            fill="none"
        >
            {edges.map(([a, b], i) => (
                <line
                    key={i}
                    x1={nodes[a].x}
                    y1={nodes[a].y}
                    x2={nodes[b].x}
                    y2={nodes[b].y}
                    stroke="rgba(201,162,75,0.28)"
                    strokeWidth="1"
                    strokeDasharray={i % 3 === 0 ? "3 5" : undefined}
                />
            ))}
            {nodes.map((n, i) => (
                <g key={i}>
                    {n.pulse && (
                        <circle
                            cx={n.x}
                            cy={n.y}
                            r={n.r + 3}
                            stroke="#C9A24B"
                            strokeWidth="1"
                            fill="none"
                            className="pulse-ring"
                            style={{ animationDelay: `${i * 0.4}s` }}
                        />
                    )}
                    <circle
                        cx={n.x}
                        cy={n.y}
                        r={n.r}
                        fill={n.r >= 5 ? "#D8BC7A" : "#8A8A80"}
                        stroke={n.r >= 5 ? "#E5CF9C" : "#A9A99E"}
                        strokeWidth="1"
                    />
                </g>
            ))}
            {labels.map((l, i) => (
                <text
                    key={i}
                    x={l.x + 12}
                    y={l.y - 8}
                    fill="rgba(201,167,115,0.75)"
                    fontSize="9"
                    fontFamily="'JetBrains Mono', monospace"
                    letterSpacing="1.5"
                >
                    {l.text}
                </text>
            ))}
            <g stroke="rgba(201,162,75,0.5)" strokeWidth="1">
                <path d="M20 20 h14 M20 20 v14" />
                <path d="M580 20 h-14 M580 20 v14" />
                <path d="M20 500 h14 M20 500 v-14" />
                <path d="M580 500 h-14 M580 500 v-14" />
            </g>
        </svg>
    );
}
